import { ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { ErrorBoundary } from './ErrorBoundary'

const StyledModal = styled.div`
  position: fixed;
  visibility: hidden;
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  align-item: center;
  justify-content: center;
  z-index: 1;

  .modal-title {
    font-weight: 400;
    border-bottom: 1.5px solid ${props => props.theme.highlightColor};
    margin: 5px 5px 10px;
    padding: 5px;
  }

  ${({ show }: { show: boolean }) =>
    show &&
    css`
      visibility: visible;
      opacity: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    `}

  .close-btn {
    float: right;
    margin: 5px;
  }

  .close-btn:hover {
    cursor: pointer;
  }

  .modal-content {
    margin: auto;
    background-color: #fff;
    padding: 15px;
    height: fit-content;
    box-shadow: 0px 2px 25px 3px rgb(0 0 0 /20%);
    border-radius: 4px;
  }

  .modal-body {
    padding: 20px 10px 20px;
    h4 {
      font-weight: 400;
    }
  }

  @media only screen and (max-width: 768px) {
    .modal-content {
      width: 90%;
      z-index: 1;
    }
  }
`

type ModalProps = {
  children: ReactNode
  onClose: () => void
  showModal: boolean
  title?: string
}

export const Modal = ({ title, children, onClose, showModal = false }: ModalProps) => {
  const onCloseClick = () => {
    onClose()
  }

  return (
    <StyledModal
      show={showModal}
      onClick={onCloseClick}
    >
      <ErrorBoundary>
        <div
          className="modal-content"
          onClick={e => e.stopPropagation()}
        >
          <i
            className="fas fa-times close-btn"
            onClick={onCloseClick}
          />
          {title && <h4 className="modal-title">{title}</h4>}
          <div className="modal-body">{children}</div>
        </div>
      </ErrorBoundary>
    </StyledModal>
  )
}
